import { render, staticRenderFns } from "./StaffSubmissionReports.vue?vue&type=template&id=576ddfd3&scoped=true&"
import script from "./StaffSubmissionReports.vue?vue&type=script&lang=js&"
export * from "./StaffSubmissionReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576ddfd3",
  null
  
)

export default component.exports